module.exports = __webpack_public_path__ + "media/images/company/company_01-c8980f3c73582d65345f280b731b7203.jpg";